import { commonService } from "../../../../utils/commonService";
import React, { useState, useEffect } from "react";

const FilterModal = ({ keyName, list, selectedData, updateFilter }) => {
  const [finalSelectedData, setFinalSelectedData] = useState({});

  useEffect(() => {
    if (selectedData && Object.keys(selectedData).length > 0) {
      setFinalSelectedData({ ...selectedData });
    } else {
      setFinalSelectedData({});
    }
  }, [selectedData]);

  const allSelected =
    list &&
    Object.keys(list).length > 0 &&
    Object.keys(finalSelectedData).length === Object.keys(list).length;

  const toggleItem = (item, checked) => {
    setFinalSelectedData((prev) => {
      const updated = { ...prev };
      if (checked) updated[item] = item;
      else delete updated[item];
      return updated;
    });
  };

  const toggleSelectAll = (checked) => {
    if (checked) {
      const updated = {};
      Object.keys(list).forEach((item) => {
        updated[item] = item;
      });
      setFinalSelectedData(updated);
    } else {
      setFinalSelectedData({});
    }
  };

  return (
    <div style={{ padding: "0 10px", width: "100%" }}>
      <div className="reservationFilterList">
        <div className="form-check" style={{ marginBottom: "8px" }}>
          <input
            className="form-check-input"
            type="checkbox"
            id="select-all"
            checked={allSelected}
            onChange={(e) => toggleSelectAll(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="select-all">
            Select All
          </label>
        </div>

        {list &&
          Object.keys(list)?.map((item) => (
            <div className="form-check" key={item}>
              <input
                className="form-check-input"
                type="checkbox"
                id={`check-${item}`}
                checked={!!finalSelectedData[item]}
                onChange={(e) => toggleItem(item, e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`check-${item}`}>
                {item}
              </label>
            </div>
          ))}
      </div>

      <div className="d-flex justify-content-end">
        <button id={commonService.generateGlobalClickTrackerID("FilterModal", "apply", "")}
          className="default-btn primary-btn"
          style={{ padding: "6px 12px", margin: "5px 0px" }}
          onClick={() => updateFilter(keyName, finalSelectedData)}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default FilterModal;
